export const STATUS = {
    APPROVED : {
        title: 'Aprovado',
        color: 'success',
    },
    REJECTED:  {
        title: 'Rejeitado',
        color: 'error',
    },
    IN_ANALYSIS:  {
        title: 'Em análise',
        color: 'warning',
    },
}


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/functional/Listing/mapped.js